import Vue from "vue";

export default class AgendaService {
  setAgenda() {
    Vue.http.options.root = process.env.AGENDA_API_URL;
    Vue.http.interceptors.push((request, next) => {
      request.headers.set("Accept", "application/json");
      request.headers.set("Content-Type", "application/json");
      request.headers.set("Access-Control-Allow-Origin", "*");
      request.headers.set(
        "Access-Control-Allow-Headers",
        "Access-Control-Allow-Methods, Access-Control-Allow-Origin, Origin, Accept, Content-Type"
      );
      request.headers.set(
        "Access-Control-Allow-Methods",
        "POST, GET, PUT, OPTIONS, DELETE"
      );
    });
  }

  setWebAdmin() {
    Vue.http.options.root = process.env.API_URL;
  }

  returnRes(param, callback) {
    this.setAgenda();
    return callback(param).then(
      res => {
        this.setWebAdmin();
        return res.json();
      },
      err => {
        this.setWebAdmin();
        throw new Error(err.body);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/domain/colegio/AgendaService.js